<ng-form #stepForm="ngForm">

    <ng-container [ngSwitch]="noPaymentNeeded">

        <p *ngSwitchCase="true"
           class="p2 col-12">{{ 'No payment information required' | translate }}</p>

        <div *ngSwitchCase="false">

            <p *ngIf="!methods.length"
               class="p2 col-12">No payment methods found.</p>

            <radio-group name="method"
                         [required]="true"
                         (change)="detectChanges()"
                         [(ngModel)]="data.method">

                <ng-container
                              *ngFor="let method of methods | applePayFilter : ['adyen_apple_pay', 'cybersource_applepay']; let isLast = last; let first = first trackBy methodTrackFn">
                    <radio2 [ngClass]="{'m-t-3 m-t-2-s m-t-2-m' : !first}"
                            [disabled]="status.busy || checkoutFormComponent.savePaymentMethodStatus.busy"
                            [value]="method.code"
                            [centerText]="true">
                        <p class="s1 p-t-3 p-b-3"
                           radioTitle>{{method.title}}</p>
                        <div [ngSwitch]="method.code"
                             class="no-wrap-s"
                             radioAside>
                            <payment-icon *ngFor="let method of getLogos(method)"
                                          [method]="method"
                                          [style.fontSize.px]="30"
                                          class="bg-col-51 m-l m-l-2-s va-m inline-block"></payment-icon>
                        </div>
                    </radio2>
                    <div class="bg-col-51 w-12 p-l-12 p-r-15 p-b-3 m-t--2"
                         *ngIf="['cybersource_applepay', 'adyen_apple_pay'].includes(method.code)">
                        <p class="col-2 c2"
                           style="padding-left: 2px">{{'Please check your ApplePay billing address matches the one
                            registered
                            with your bank.' | translate}}</p>
                    </div>
                    <div class="p-t-3 cursor-auto bg-col-51 p-l-3 p-r-3 p-b"
                         [class.visually-hidden]="!isSelected(method)"
                         *ngIf="(methodAsCard(method).isCard || ['adyen_cc', 'vfinance', 'chcybersource'].includes(asString(method.code)))"
                         radioBottom>

                        <adyen-secured-fields *ngIf="method.code === 'adyen_cc'"
                                              class="block m-t-7">
                        </adyen-secured-fields>

                        <v12-retail-finance class="block"
                                            *ngIf="method.code === 'vfinance'"></v12-retail-finance>
                        <barclaycard-flex-microform
                                                    *ngIf="method.code === 'chcybersource' && isSelected(method)"></barclaycard-flex-microform>

                        <ng-container *ngIf="methodAsCard(method).isCard"
                                      [ngSwitch]="methodAsCard(method).method">

                            <div class="s2"
                                 cy-checkoutSavedCard>
                                Exp: {{methodAsCard(method).data.expiry_date}}
                            </div>
                            <checkout-vault-card *ngSwitchCase="'vault'"
                                                 class="block"
                                                 [card]="methodAsCard(method)">
                            </checkout-vault-card>
                        </ng-container>
                    </div>
                </ng-container>
            </radio-group>

            <input-wrap>
                <input type="hidden"
                       [(ngModel)]="data.method"
                       name="paymentMethod"
                       required>
            </input-wrap>

        </div>
    </ng-container>
</ng-form>
